import React, { useEffect, useState } from 'react'
import { useLoginHook } from 'hooks'
import { useLocation } from 'react-router-dom'

import { RedirectSingleSpa as Redirect } from 'components/RedirectSingleSpa'
import { FullPageLoading } from 'components'
import { getQueryParamsValue } from 'utils'
import { ROUTES_PATH } from 'constants/routesPath'
import { useAuthentication } from 'redesign/hooks/useAuthentication'
import { KEEP_LOGGED_LS_KEY } from 'constants/app'

export function Logout() {
    const location = useLocation()
    const [redirectPath, setRedirectPath] = useState<string | undefined>(undefined)
    const { signOut } = useLoginHook()
    const { logout } = useAuthentication()

    useEffect(() => {
        const origin = getQueryParamsValue(location, 'origin')
        if (origin !== 'sessao-expirada') {
            localStorage.removeItem(KEEP_LOGGED_LS_KEY)
        }

        if (!redirectPath) {
            try {
                logout()
                signOut()
                localStorage.removeItem('userName')
                // eslint-disable-next-line no-empty
            } catch (e) {}
            const path: string = getQueryParamsValue(location, 'redirectTo') || ROUTES_PATH.LANDING_PAGE
            setRedirectPath(path)
        }
    }, [location, logout, redirectPath, signOut])

    return (
        <>
            <FullPageLoading />
            {redirectPath && <Redirect to={redirectPath} />}
        </>
    )
}
